import React, { useEffect } from "react";
import "./styles.css";
import { useNavigate } from "react-router-dom";
import Navbar from "../GeneralComponents/Navbar";
import SideNav from "../GeneralComponents/SideNav";
import { ReactComponent as Bubbles } from "./SignupSuccess.svg";

function SignupSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate("/login");
    }, 5000);
  });

  return (
    <div className="grid grid-cols-1 lg:grid-cols-4">
      <SideNav />
      <div className="col-span-1 lg:col-span-3">
        <Navbar />
        <div className="bg-[#F3F5F9] flex flex-col items-center md:mt-4 lg:mt-4 border h-screen lg:h-[500px] rounded-3xl lg:pb-16 lg:w-[400px] lg:mx-auto lg:scale-[80%]">
          <Bubbles />
          <span className="loader" />
        </div>
      </div>
    </div>
  );
}

export default SignupSuccess;
